import {
	Globe,
	Phone,
	Mail,
	MapPin,
	ArrowRight,
	MessageCircle,
} from 'lucide-react';

const LinkedInIcon = ({ size = 14, color = 'currentColor', style }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={size}
		height={size}
		viewBox='0 0 24 24'
		fill={color}
		style={style}
		aria-hidden='true'>
		<path d='M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.04-1.85-3.04-1.86 0-2.14 1.45-2.14 2.94v5.67H9.36V9h3.41v1.56h.05c.47-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.22 0z' />
	</svg>
);
import whatsappLogo from '../assets/whatsapp-logo.svg';

const CALENDAR_URL = 'https://calendar.app.google/DtBNRYcoX9a3oD5a9';
const WHATSAPP_URL =
	'https://wa.me/919351275556?text=Hi%2C%20I%27d%20like%20to%20enquire%20about%20your%20India-UK%20tax%20advisory%20services.';
const LINKEDIN_URL =
	'https://www.linkedin.com/in/ca-aditya-ghiya-365255117';

const quickLinks = [
	{ label: 'Home', id: null },
	{ label: 'Services', id: 'services' },
	{ label: 'About Us', id: 'about' },
	{ label: 'Certifications', id: 'certifications' },
	{ label: 'Book Consultation', href: CALENDAR_URL },
];

const services = [
	{ label: 'Tax Return Filing', serviceId: 1 },
	{ label: 'Double Taxation Avoidance', serviceId: 2 },
	{ label: 'Foreign Remittance', serviceId: 3 },
	{ label: 'QROPS Pension Transfer', serviceId: 5 },
	{ label: 'Virtual CFO Services', serviceId: 9 },
	{ label: 'Business Setup & Growth', serviceId: 7 },
	{ label: 'Audit & Assurance', serviceId: 8 },
	{ label: 'Strategic Investment Advisory', serviceId: 6 },
	{ label: 'PF Withdrawal', serviceId: 4 },
];

const scrollTo = (id) => {
	if (id) {
		document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
	} else {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}
};

const openService = (serviceId) => {
	document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
	setTimeout(() => {
		window.dispatchEvent(
			new CustomEvent('open-service', { detail: { serviceId } }),
		);
	}, 600);
};

const Footer = () => {
	return (
		<footer data-testid='footer' role='contentinfo' aria-label='Site footer' style={{ backgroundColor: '#111827' }}>
			<div className='max-w-6xl mx-auto px-6 py-14'>
				<div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10'>
					{/* Brand */}
					<div className='lg:col-span-1 space-y-4'>
						<div className='flex items-center gap-3'>
							<div
								className='w-10 h-10 rounded-xl flex items-center justify-center text-white font-bold text-sm flex-shrink-0'
								style={{ backgroundColor: '#2D5A8C' }}>
								AG
							</div>
							<div>
								<div
									className='font-semibold text-sm text-white'
									style={{ fontFamily: "'Outfit', sans-serif" }}>
									Aditya Ghiya & Associates
								</div>
								<div className='text-xs' style={{ color: '#6B7280' }}>
									India-UK Tax Specialists
								</div>
							</div>
						</div>
						<p className='text-sm leading-relaxed' style={{ color: '#9CA3AF' }}>
							Expert cross-border tax advisory for expats, NRIs, and businesses
							navigating India-UK financial complexities.
						</p>
						<div className='flex flex-wrap gap-2'>
							<a
								href={CALENDAR_URL}
								target='_blank'
								rel='noopener noreferrer'
								className='inline-flex items-center gap-2 px-4 py-2.5 rounded-lg text-xs font-semibold text-white transition-all duration-200 hover:opacity-90'
								style={{ backgroundColor: '#F59E0B' }}>
								Book Consultation
								<ArrowRight size={12} />
							</a>
							<a
								href={WHATSAPP_URL}
								target='_blank'
								rel='noopener noreferrer'
								className='inline-flex items-center gap-2 px-4 py-2.5 rounded-lg text-xs font-semibold text-white transition-all duration-200 hover:opacity-90'
								style={{ backgroundColor: '#25D366' }}>
								<img src={whatsappLogo} alt='' className='w-5 h-5 -mx-1' />
								WhatsApp
							</a>
						</div>
					</div>

					{/* Quick Links */}
					<div>
						<h4 className='font-semibold text-sm text-white mb-5'>
							Quick Links
						</h4>
						<ul className='space-y-3'>
							{quickLinks.map(({ label, id, href }) => (
								<li key={label}>
									{href ? (
										<a
											href={href}
											target='_blank'
											rel='noopener noreferrer'
											className='text-sm transition-colors duration-200 hover:text-white'
											style={{ color: '#9CA3AF' }}>
											{label}
										</a>
									) : (
										<button
											onClick={() => scrollTo(id)}
											className='text-sm transition-colors duration-200 hover:text-white text-left'
											style={{ color: '#9CA3AF' }}>
											{label}
										</button>
									)}
								</li>
							))}
						</ul>
					</div>

					{/* Services */}
					<div>
						<h4 className='font-semibold text-sm text-white mb-5'>
							Our Services
						</h4>
						<ul className='space-y-3'>
							{services.map(({ label, serviceId }) => (
								<li key={label}>
									<button
										onClick={() => openService(serviceId)}
										className='text-sm transition-colors duration-200 hover:text-white text-left'
										style={{ color: '#9CA3AF' }}>
										{label}
									</button>
								</li>
							))}
						</ul>
					</div>

					{/* Contact */}
					<div>
						<h4 className='font-semibold text-sm text-white mb-5'>
							Contact Us
						</h4>
						<ul className='space-y-4'>
							<li className='flex items-start gap-3'>
								<Mail
									size={14}
									style={{ color: '#6B7280', marginTop: '2px', flexShrink: 0 }}
								/>
								<a
									href='mailto:Info@ghiyaassociates.com'
									className='text-sm transition-colors duration-200 hover:text-white'
									style={{ color: '#9CA3AF' }}>
									Info@ghiyaassociates.com
								</a>
							</li>
							<li className='flex items-start gap-3'>
								<Globe
									size={14}
									style={{ color: '#6B7280', marginTop: '2px', flexShrink: 0 }}
								/>
								<a
									href='https://ghiyaassociates.com'
									target='_blank'
									rel='noopener noreferrer'
									className='text-sm transition-colors duration-200 hover:text-white'
									style={{ color: '#9CA3AF' }}>
									ghiyaassociates.com
								</a>
							</li>
							<li className='flex items-start gap-3'>
								<MessageCircle
									size={14}
									style={{ color: '#6B7280', marginTop: '2px', flexShrink: 0 }}
								/>
								<a
									href={WHATSAPP_URL}
									target='_blank'
									rel='noopener noreferrer'
									className='text-sm transition-colors duration-200 hover:text-white'
									style={{ color: '#9CA3AF' }}>
									+91 93512 75556
								</a>
							</li>
							<li className='flex items-start gap-3'>
								<MapPin
									size={14}
									style={{ color: '#6B7280', marginTop: '2px', flexShrink: 0 }}
								/>
								<span className='text-sm' style={{ color: '#9CA3AF' }}>
									Jaipur · Ajmer · Mumbai · London
								</span>
							</li>
							<li className='flex items-start gap-3'>
								<LinkedInIcon
									size={14}
									style={{ color: '#6B7280', marginTop: '2px', flexShrink: 0 }}
								/>
								<a
									href={LINKEDIN_URL}
									target='_blank'
									rel='noopener noreferrer'
									aria-label='Connect with CA Aditya Ghiya on LinkedIn'
									className='text-sm transition-colors duration-200 hover:text-white'
									style={{ color: '#9CA3AF' }}>
									LinkedIn
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>

			{/* Bottom bar */}
			<div className='border-t px-6 py-5' style={{ borderColor: '#1F2937' }}>
				<div className='max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3'>
					<p className='text-xs' style={{ color: '#6B7280' }}>
						&copy; {new Date().getFullYear()} Aditya Ghiya & Associates. All
						rights reserved.
					</p>
					<p className='text-xs' style={{ color: '#6B7280' }}>
						India-UK Tax Advisory | CA India | ICAEW
					</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
